import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Colors } from "theme/colors";
import { fontKrub, fontQuicksand } from "theme/fonts";

export const StyledTableCell = styled.div`
  display: table-cell;
  cursor: default;
  line-height: 1.5rem;
`;

interface HeaderCellProps {
  $width?: number;
}

export const StyledTableHeaderCell = styled(StyledTableCell)<HeaderCellProps>`
  padding: 0 1rem 0.5rem 1rem;
  color: ${Colors.BLUE};
  vertical-align: bottom;
  ${fontQuicksand()}

  ${(props) =>
    props.$width &&
    css`
      width: ${props.$width}px; // px is fine as it comes from the user
    `}
`;

export const StyledTableBodyCell = styled(StyledTableCell)`
  padding: 0.5rem 1rem 0.5rem 1rem;
  color: ${Colors.TEXT_GRAY};
  ${fontKrub()};
  font-size: 0.9375rem;
  cursor: default;
  word-wrap: break-word;
`;
